import React, { FC } from 'react';
import Svg, { Circle } from 'react-native-svg';
import { CircleBarProps } from '@components/common/CircleBar/types';

const CircleBar: FC<CircleBarProps> = ({ size, strokeWidth, progress, color, trackColor, counterClockwise }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clampedProgress = Math.min(Math.max(progress, 0), 1);
  const filledLength = circumference * clampedProgress;
  const cx = size / 2;
  const cy = size / 2;
  const rotation = counterClockwise ? -90 - 360 * clampedProgress : -90;

  return (
    <Svg width={size} height={size}>
      <Circle
        stroke={trackColor}
        fill="transparent"
        cx={cx}
        cy={cy}
        r={radius}
        strokeWidth={strokeWidth}
      />
      {clampedProgress > 0 && (
        <Circle
          stroke={color}
          fill="transparent"
          cx={cx}
          cy={cy}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={`${filledLength}, ${circumference - filledLength}`}
          strokeLinecap="round"
          transform={`rotate(${rotation} ${cx} ${cy})`}
        />
      )}
    </Svg>
  );
};

export default CircleBar;
